export function formatKobo(kobo) {
  if (kobo == null) return "";
  return "\u20a6" + Math.round(kobo / 100).toLocaleString("en-NG");
}

export function displayPrice(item) {
  if (item.variants && item.variants.length) {
    const prices = item.variants.map((v) => v.price);
    return "from " + formatKobo(Math.min(...prices));
  }
  return formatKobo(item.price || 0);
}
